import React, { createContext, useReducer } from "react";
import { signupFormInitialState, signupFormReducer } from "./signup-form-context.jsx";


const signupFormStore = createContext(signupFormInitialState);
const { Provider } = signupFormStore;

const SignupFormStateProvider = ({children}) => {
    const [state, dispatch] = useReducer(signupFormReducer, signupFormInitialState);
    return <Provider value={{state, dispatch}}>{children}</Provider>
}

export {signupFormStore, SignupFormStateProvider}